(function () {
  'use strict';
  function initialise() {
    var sticky = document.querySelector('[data-titsco-sticky-bridge]');
    var main = document.getElementById('AddToCart-product-template');
    if (!sticky || !main) return;
    var form = main.closest('form');
    var action = sticky.querySelector('[data-sticky-action]');
    var summary = sticky.querySelector('[data-sticky-selection]');
    if (!form || !action || !summary) return;
    var variants = [];
    var json = document.getElementById('ProductJson-product-template');
    if (json) {
      try { variants = JSON.parse(json.textContent).variants || []; }
      catch (error) { return; }
    }
    function needsSize() {
      return main.classList.contains('titsco-size-required') ||
        /choose a size/i.test(main.textContent);
    }
    function selectedVariant() {
      var master = form.querySelector('[name="id"]');
      return master && variants.find(function (variant) {
        return String(variant.id) === String(master.value);
      });
    }
    function refresh() {
      var choose = needsSize();
      var selected = selectedVariant();
      var invalid = !choose && (!selected || selected.available === false);
      if (invalid) {
        if (!main.hasAttribute('data-titsco-invalid-variant')) main.setAttribute('data-titsco-invalid-variant', 'true');
        if (!main.disabled) main.disabled = true;
        var unavailableText = selected ? 'Sold out' : 'Unavailable';
        if (main.textContent.trim() !== unavailableText) main.textContent = unavailableText;
      } else if (!choose && main.hasAttribute('data-titsco-invalid-variant')) {
        main.removeAttribute('data-titsco-invalid-variant');
        main.disabled = false;
        if (main.textContent.trim() !== 'Add to cart') main.textContent = 'Add to cart';
      }
      var label = choose ? 'Choose a size' : main.textContent.trim();
      if (action.textContent !== label) action.textContent = label;
      var disabled = invalid || (!choose && main.disabled);
      if (action.disabled !== disabled) action.disabled = disabled;
      var selectionText = choose ? 'Select your size above' :
        (selected && selected.title !== 'Default Title' ? selected.title : 'Unavailable selection');
      if (summary.textContent !== selectionText) summary.textContent = selectionText;
      sticky.setAttribute('data-ready', 'true');
    }
    function guardUnavailable(event) {
      var selected = selectedVariant();
      if (needsSize() || !selected || selected.available === false) {
        event.preventDefault();
        event.stopImmediatePropagation();
        refresh();
      }
    }
    main.addEventListener('click', guardUnavailable, true);
    form.addEventListener('submit', guardUnavailable, true);
    action.addEventListener('click', function () {
      refresh();
      if (main.disabled || needsSize()) {
        form.scrollIntoView({block: 'center', behavior: 'smooth'});
        var size = form.querySelector('.swatch[data-option-index="1"] input:not(:disabled)');
        if (size) size.focus({preventScroll: true});
        return;
      }
      // Submit through the existing main button, preserving variant, quantity and validation.
      main.click();
    });
    form.addEventListener('change', function () { window.setTimeout(refresh, 0); });
    new MutationObserver(refresh).observe(main, {attributes: true, childList: true, subtree: true});
    refresh();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else { initialise(); }
})();

